import Vue from 'vue'
import tmpColors from 'vuetify/es5/util/colors'

const colors = Object.assign({
    blueGradient: 'linear-gradient(180deg, #03A9F4, #0288D1)',
    blueGradientDark: 'linear-gradient(90deg, #0288D1, #0277BD)',
    blueShadow: '0px 10px 20px rgb(3,169,244,0.45) !important',
    beige: '#F5F3F1',
    cyanGradient: 'linear-gradient(180deg, #0097A7, #00ACC1)',
    cyanShadow: '0px 10px 20px rgb(76,175,80,0.45) !important',
    greenGradient: 'linear-gradient(180deg, #4CAF50, #388E3C)',
    greenGradientDark: 'linear-gradient(90deg, #388E3C, #2E7D32)',
    greenShadow: '0px 10px 20px rgb(76,175,80,0.45) !important',
    indigoGradient: 'linear-gradient(180deg, #3F51B5, #303F9F)',
    indigoShadow: '0px 10px 20px rgb(63,81,181,0.45) !important',
    lemon: '#FFC107',
    mdGray1: '#e2e2e2',
    mdGray2: '#979797',
    mdGray3: '#4d4d4d',
    mdGray4: '#323232',
    mdPurple: '#6142B0',
    mdPurple50: '#A08ED0',
    mdPurple70: '#8168C0',
    mdLightPurple: '#BD95FF',
    mdLightPurple50: '#D7BFFF',
    mdLightPurple70: '#CAAAFF',
    mdYellow: '#E7A730',
    orangeGradient: 'linear-gradient(180deg, #FF9800, #F57C00)',
    orangeGradientDark: 'linear-gradient(90deg, #F57C00, #EF6C00)',
    orangeShadow: '0px 10px 20px rgb(255,152,0,0.45) !important',
    primary: '#6142b0',
    purpleGradient: 'linear-gradient(180deg, #9C27B0, #7B1FA2)',
    purpleShadow: '0px 10px 20px rgb(156,39,176,0.45) !important',
    ruby: '#E91E63',
    rubyGradient: 'linear-gradient(180deg, #E91E63, #C2185B)',
    rubyShadow: '0px 10px 20px rgb(233,30,99,0.45) !important',
    snapdeskGreen: '#4CAF50',
    snapdeskOrange: '#FF9800',
}, tmpColors)

Vue.prototype.$colors = colors

export default colors
